import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FadeScrollWrapper, ICONS, ScrollBar } from '@app/styles';
import { _className, AwaitModules, ComponentSync, DataStatus, LL_H_C, LL_V_L, openContent, TS_Input } from '@nu-art/thunderstorm-frontend';
import { createRef } from 'react';
import { _keys, asArray, dbObjectToId, Filter, sortArray } from '@nu-art/ts-common';
import { ModuleFE_DiseaseValue, ModuleFE_DiseaseView, ModuleFE_MultiVar } from '../../../../../_entity.js';
import { ModuleFE_Variable } from '@app/hcs-frontend';
import './Panel_MultiVarList.scss';
import { Preview_NewMultiVar } from '../Editor_MultiVar/Preview_NewMultiVar/Preview_NewMultiVar.js';
import { noDiseaseViewId } from '../../consts.js';
export class Panel_MultiVarList extends ComponentSync {
    scrollRef = createRef();
    // ######################## Life Cycle ########################
    __onMultiVarUpdated = (...params) => {
        const currentDPId = this.props.renderArgs.itemId;
        const currentDVId = this.props.renderArgs.profile.selectedDiseaseViewId;
        const mvs = asArray(params[1]);
        if (mvs.find(mv => mv.diseaseProfileId === currentDPId))
            this.setState({ diseaseValueRelationMap: this.calculateRelationMap(currentDPId, currentDVId) });
    };
    __onDiseaseValueUpdated = (...params) => {
        const currentDPId = this.props.renderArgs.itemId;
        const currentDVId = this.props.renderArgs.profile.selectedDiseaseViewId;
        const dvs = asArray(params[1]);
        if (dvs.find(dv => dv._diseaseProfileId === currentDPId))
            this.setState({ diseaseValueRelationMap: this.calculateRelationMap(currentDPId, currentDVId) });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        state.tabId = nextProps.tabId;
        state.chiefComplaintIds = nextProps.chiefComplaintIds;
        state.diseaseValueRelationMap = this.calculateRelationMap(nextProps.renderArgs.itemId, nextProps.renderArgs.profile.selectedDiseaseViewId);
        return state;
    }
    // ######################## Logic ########################
    getRelatedMultiVars(diseaseProfileId, diseaseViewId) {
        const multiVars = ModuleFE_MultiVar.cache.filter(mv => mv.diseaseProfileId === diseaseProfileId);
        if (diseaseViewId === noDiseaseViewId)
            return multiVars.filter(mv => ModuleFE_DiseaseView.checkVariableMatchesNoViews(mv));
        const diseaseView = ModuleFE_DiseaseView.cache.unique(diseaseViewId);
        if (!diseaseView)
            return [];
        return multiVars.filter(mv => ModuleFE_DiseaseView.filterMultiVarByEnforcedTag(diseaseView, mv));
    }
    calculateRelationMap(diseaseProfileId, diseaseViewId) {
        const mvs = this.getRelatedMultiVars(diseaseProfileId, diseaseViewId);
        return mvs.reduce((map, mv) => {
            const dvs = ModuleFE_DiseaseValue.cache.filter(dv => dv.multiVarId === mv._id);
            map[mv._id] = dvs.map(dbObjectToId);
            return map;
        }, {});
    }
    selectMV = (mvId) => {
        if (mvId === this.state.renderArgs.multiVar.id)
            return;
        const args = { ...this.state.renderArgs.multiVar, id: mvId };
        this.props.workHubItem.updateArgs(this.state.tabId, { multiVar: args });
    };
    onSearchTermChange = (value) => {
        const newArgs = { ...this.state.renderArgs.multiVar, searchTerm: value };
        this.props.workHubItem.updateArgs(this.state.tabId, { multiVar: newArgs });
    };
    getMVIdsToRender = () => {
        let mvIds = _keys(this.state.diseaseValueRelationMap);
        if (ModuleFE_Variable.getDataStatus() !== DataStatus.ContainsData)
            return mvIds;
        const mvToName = mvIds.reduce((map, id) => {
            const mv = ModuleFE_MultiVar.cache.unique(id);
            const variable = ModuleFE_Variable.cache.unique(mv?._firstVarId);
            if (variable)
                map[id] = variable.name.toLowerCase();
            return map;
        }, {});
        //Filter by search term
        if (this.state.renderArgs.multiVar?.searchTerm) {
            const filter = new Filter(id => [mvToName[id]]);
            mvIds = filter.filter(mvIds, this.state.renderArgs.multiVar.searchTerm);
        }
        //Sort results
        sortArray(mvIds, id => mvToName[id]);
        //Sort by amount of disease values
        sortArray(mvIds, id => this.state.diseaseValueRelationMap[id]?.length ?? 0, true);
        return mvIds;
    };
    addNewMultiVar = () => {
        Preview_NewMultiVar.show(this.state.renderArgs.itemId, this.state.renderArgs.profile.selectedDiseaseViewId, (multiVar) => {
            this.props.workHubItem.updateArgs(this.state.tabId, {
                multiVar: { ...this.state.renderArgs.multiVar, id: multiVar._id }
            });
        });
    };
    getMVIssues = (mv) => {
        const issues = [];
        if (!this.state.diseaseValueRelationMap[mv._id].length)
            issues.push('Multi Var has no values');
        if (!mv.referenceIds.length)
            issues.push('Multi Var has no references');
        return issues;
    };
    // ######################## Render ########################
    render() {
        const mvIds = this.getMVIdsToRender();
        return _jsxs(LL_H_C, { className: 'panel__multi-var-list', children: [_jsxs(LL_V_L, { className: 'panel__multi-var-list__content', children: [this.render_Header(), _jsx(AwaitModules, { modules: [ModuleFE_Variable], children: _jsx(FadeScrollWrapper, { scrollRef: this.scrollRef, children: mvIds.map(id => this.render_MultiVar(id)) }) })] }), _jsx(ScrollBar, { scrollableRef: this.scrollRef })] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'panel__multi-var-list__header', children: [_jsxs(LL_H_C, { className: 'panel__multi-var-list__search', children: [_jsx(TS_Input, { type: 'text', placeholder: 'Search', value: this.state.renderArgs.multiVar.searchTerm, onBlur: value => this.onSearchTermChange(value) }), _jsx(ICONS.search.component, {})] }), this.state.renderArgs.editMode && _jsx(ICONS.advisor_avn_add.component, { onClick: this.addNewMultiVar })] });
    };
    render_MultiVar = (mvId) => {
        const mv = ModuleFE_MultiVar.cache.unique(mvId);
        if (!mv)
            return;
        const baseVariable = ModuleFE_Variable.cache.unique(mv._firstVarId);
        const dvCount = this.state.diseaseValueRelationMap[mv._id].length;
        const issues = this.getMVIssues(mv);
        const className = _className('multi-var', this.state.chiefComplaintIds.includes(mv._firstVarId) && 'cc', mv._id === this.state.renderArgs.multiVar.id && 'selected');
        return _jsxs(LL_H_C, { className: className, onClick: () => this.selectMV(mvId), children: [_jsx("div", { className: 'mv-status' }), _jsx("div", { className: 'mv-name', children: baseVariable?.name ?? 'N/A' }), !!issues.length && _jsx(ICONS.advisor_v5_warning_exclamation_mark.component, { className: 'mv-warning', ...openContent.tooltip.top('tooltip__mv-warning', issues.join('\n')) }), _jsx("div", { className: 'mv-dv-count', children: dvCount })] }, mvId);
    };
}
//# sourceMappingURL=Panel_MultiVarList.js.map